
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function relatedItemsRT () {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatI1(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                return _createElement('div', { 'className': 'element mb30' }, _createElement('div', { 'className': 'main_box' }, _createElement('div', { 'className': 'box_1' }, _createElement('div', { 'className': 'cm_badge-container' }, this.on_sale ? _createElement('div', {
                    'className': 'cm_badge on-sale',
                    'key': '123'
                }, '\n          ', Math.ceil((1 - this.price / this.compare_at_price) * 100), '% off\n        ') : null, this.out_of_stock ? _createElement('div', {
                    'className': 'cm_badge sold-out',
                    'key': '273'
                }, 'Sold out') : null, this.New ? _createElement('div', {
                    'className': 'cm_badge cm_badge__new',
                    'key': '353'
                }, 'New') : null, this.Closeout ? _createElement('div', {
                    'className': 'cm_badge cm_badge__closeout',
                    'key': '424'
                }, 'Closeout') : null), _createElement('div', { 'className': 'product-image' + (this.image2 ? ' has_second_image' : '') }, _createElement('a', { 'href': this.url }, _createElement('img', {
                    'className': 'main_image lazyloaded',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'onError': this.onImageError,
                    'data-aspectratio': '1',
                    'data-parent-fit': 'contain',
                    'alt': 'Image of ' + this.removeHTML(this.title)
                }), this.image2 ? _createElement('img', {
                    'className': 'second_image lazyloaded',
                    'src': this.imageOrDefault(this.resizeImage(this.image2)),
                    'onError': this.onImageError,
                    'data-aspectratio': '1',
                    'data-parent-fit': 'contain',
                    'alt': 'Second image of ' + this.removeHTML(this.title),
                    'key': '876'
                }) : null))), _createElement('div', { 'className': 'desc' }, _createElement('h5', {}, _createElement('a', Object.assign({}, { 'href': this.url }, { dangerouslySetInnerHTML: { __html: this.title } }))), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '13030'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI1.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], _createElement('div', { 'className': 'price' }, _createElement('span', { 'className': 'money' }, '\n          ', this.price_varies ? `From: ${ this.formatPrice(this.price) }` : this.formatPrice(this.price), '\n        '), _createElement('span', { 'className': 'compare-price money' }, this.formatPrice(this.compare_at_price))), _createElement('div', { 'className': 'cm_product-item__buttons' }, _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'cm_product-item__buttons-form',
                    'id': this.id,
                    'encType': 'multipart/form-data'
                }, this.variant_ids.length > 1 || this.product_type?.includes('OEM Schematic') ? [_createElement('a', {
                        'className': 'cm_button cm_button__secondary',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '21691'
                    }, '\n              ', this.product_type?.includes('OEM Schematic') ? 'Show Details' : this.out_of_stock ? 'Sold out' : 'Select options', '\n            ')] : null, this.variant_ids.length === 1 && !this.product_type?.includes('OEM Schematic') ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '26071'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '26073'
                    }),
                    _createElement('button', {
                        'className': 'cm_button cm_button__primary',
                        'type': 'submit',
                        'data-form-id': this.id,
                        'disabled': this.out_of_stock,
                        'key': '26075'
                    }, this.out_of_stock ? ['Sold out'] : null, !this.out_of_stock ? [
                        '\n                Add to cart',
                        this.set_qty ? ` Set of ${ this.set_qty }` : '',
                        '\n              '
                    ] : null)
                ] : null)))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, 'You might also like...')), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []